import React from "react";
import {
  Box,
  Typography,
  Stack,
  Tooltip,
  IconButton,
  Chip,
  Divider,
  CardContent,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined";
import PersonOutlineIcon from "@mui/icons-material/PersonOutlineOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

import { StyledCard } from "../common/StyledCard";
import { StudentFeeAllocationResponseDto } from "../../shared/dtos/studentFeeAllocation/StudentFeeAllocationResponseDto";

interface FeeAllocationCardProps {
  allocation: StudentFeeAllocationResponseDto;
  onDelete?: () => void;
}

const FeeAllocationCard: React.FC<FeeAllocationCardProps> = ({
  allocation,
  onDelete,
}) => {
  return (
    <StyledCard>
      <CardContent
        sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%" }}
      >
        {/* Header */}
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "flex-start",
            mb: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <AccountBalanceWalletOutlinedIcon color="primary" />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {allocation.voteHeadName}
            </Typography>
          </Box>
          <Stack direction="row">
            {onDelete && (
              <Tooltip title="Remove Allocation">
                <IconButton size="small" color="error" onClick={onDelete}>
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Stack>

        <Divider sx={{ my: 1.5 }} />

        {/* Body Details */}
        <Stack spacing={1} sx={{ flexGrow: 1 }}>
          <Chip
            icon={<PersonOutlineIcon />}
            label={`${allocation.studentName || "N/A"} (${allocation.studentAdmissionNumber || "No ID"})`}
            size="small"
            sx={{ justifyContent: "flex-start", py: 0.5 }}
          />
          <Chip
            icon={<CalendarTodayIcon />}
            label={allocation.academicYearName || "Academic Year"}
            size="small"
            variant="outlined"
            sx={{ justifyContent: "flex-start", py: 0.5 }}
          />

          {allocation.narrative && (
            <Typography
              variant="caption"
              sx={{ color: "text.secondary", mt: 1 }}
            >
              Note: {allocation.narrative}
            </Typography>
          )}
        </Stack>
      </CardContent>
    </StyledCard>
  );
};

export default FeeAllocationCard;
